import React, { ReactNode } from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { colorsTheme } from 'resources/theme/styled/colors';
import { StyledComponentProps } from 'typings/common';
import { IntakeFormStatus, IntakeFormTypes } from 'api/crm/intakeFormAPI';

// components
import DivAlignCenter from 'components/Additional/DivAlignCenter';
import { CardWrapper } from 'components/Additional/CardWrapper';
import { Text, IconSVG, Col, Row } from '@ui';
import { ReactComponent as GroupIcon } from 'resources/icons/remix-icons/survey-line.svg';

interface IProps extends StyledComponentProps {
  data: {
    name: string;
    type: IntakeFormTypes;
    status: IntakeFormStatus;
  };
  onClick?: () => void;
  children?: ReactNode;
  removeMargin?: boolean;
}

const ApplicationDetails = ({
  data,
  children,
  removeMargin,
  ...rest
}: IProps) => {
  const { t } = useTranslation('connections');

  return (
    <StyledCardWrapper noMargin={removeMargin} {...rest}>
      <Row gutter={[10, 10]}>
        <Col flex={1} span={24}>
          <Content>
            <StyledIconSVG
              size="middle"
              component={GroupIcon}
              color={colorsTheme.colorWhite}
            />
            <StyledDivAlignCenter>
              <Text variant="h6" weight="bold" color={colorsTheme.colorWhite}>
                {data.name}
              </Text>
              <Text>
                {t('applications.type')}
                <StyledText variant="span" weight="semi-bold">
                  {t(`applications.types.${data.type}`)}
                </StyledText>
              </Text>
              <Text>
                {t('applications.status')}
                <StyledText variant="span" weight="semi-bold">
                  {t(`applications.state.${data.status}`)}
                </StyledText>
              </Text>
            </StyledDivAlignCenter>
          </Content>
        </Col>
        {children && <Col>{children}</Col>}
      </Row>
    </StyledCardWrapper>
  );
};

const StyledIconSVG = styled(IconSVG)`
  margin-right: ${({ theme }) => theme.marginSm};
  margin-top: 3px;
`;

const StyledText = styled(Text)`
  margin-left: ${({ theme }) => theme.marginXXs};
`;

const StyledDivAlignCenter = styled(DivAlignCenter)`
  flex-direction: column;
  align-items: start;
`;

const Content = styled.div`
  display: flex;
  align-items: start;
`;

const StyledCardWrapper = styled(CardWrapper)`
  width: 100%;
  padding: ${({ theme }) => theme.paddingXl};
`;

export default ApplicationDetails;
